import { useParams } from "react-router";
import { Breadcrumbs } from "@/components/page";
import { TaskDetail } from "@/components/tasks/TaskDetail";
import { epicPath } from "@/lib/areas";
import { useProject } from "@/lib/project";
import { useEpics, useSprints, useTask } from "@/lib/queries";
import { taskKey } from "@/lib/utils";

export function TaskPage() {
  const { tid = "" } = useParams();
  const { pid, bundle } = useProject();
  const task = useTask(pid, tid);
  const epics = useEpics(pid);
  const sprints = useSprints(pid, task.data?.epicId);
  const t = task.data;
  const epic = epics.data?.find((e) => e.id === t?.epicId);
  const sprint = sprints.data?.find((s) => s.id === t?.sprintId);

  const crumbs = [{ label: bundle.project.name, to: `/p/${pid}` }];
  if (epic) crumbs.push({ label: epic.title, to: epicPath(pid, epic) });
  if (sprint) crumbs.push({ label: sprint.title, to: `/p/${pid}/sprints/${sprint.id}` });
  if (t) crumbs.push({ label: taskKey(bundle.project.key, t.number), to: "" });

  return (
    <>
      <Breadcrumbs items={crumbs.map((c) => ({ label: c.label, to: c.to || undefined }))} />
      <div className="mx-auto max-w-3xl px-6 pt-8 pb-24 md:px-12">
        <TaskDetail key={tid} taskId={tid} mode="page" />
      </div>
    </>
  );
}
